export default __webpack_public_path__ + "static/media/bicca-v3.17746476.jpg";